export type DayOfWeek = 'mon' | 'tue' | 'wed' | 'thu' | 'fri' | 'sat' | 'sun';

export const DAY_LABELS: Record<DayOfWeek, string> = {
  mon: 'Montag',
  tue: 'Dienstag',
  wed: 'Mittwoch',
  thu: 'Donnerstag',
  fri: 'Freitag',
  sat: 'Samstag',
  sun: 'Sonntag',
};

export type BandColor = 'gruen' | 'orange' | 'rot' | 'schwarz';

export type ExerciseCategory =
  | 'push'
  | 'pull'
  | 'legs'
  | 'core'
  | 'cardio'
  | 'mobility';

export const CATEGORY_LABEL: Record<ExerciseCategory, string> = {
  push: 'Push',
  pull: 'Pull',
  legs: 'Beine',
  core: 'Core',
  cardio: 'Cardio',
  mobility: 'Mobility',
};

export const CATEGORY_ORDER: readonly ExerciseCategory[] = [
  'push',
  'pull',
  'legs',
  'core',
  'cardio',
  'mobility',
] as const;

export type EquipmentType =
  | 'plattform'
  | 'matte'
  | 'frei'
  | 'curlbar'
  | 'griffe'
  | 'fussschlaufen'
  | 'tueranker'
  | 'kurzes-band'
  | 'langes-band';

export interface BandColorPair {
  long?: BandColor;
  short?: BandColor;
}

export type ExerciseIconKey =
  | 'core'
  | 'glutes'
  | 'cardio'
  | 'antirotation'
  | 'plank'
  | 'mobility';

export interface Exercise {
  id: string;
  bookNumber?: string;
  pdfPage?: number;
  name: string;
  muscles: string;
  categories: ExerciseCategory[];
  bandColor?: BandColorPair;
  equipment: EquipmentType[];
  setupNote?: string;
  instructions: string[];
  tip?: string;
  lwsSafe: boolean;
  lwsNote?: string;
  imagePath?: string;
  iconKey?: ExerciseIconKey;
}

export interface PlanEntry {
  exerciseId: string;
  sets: number;
  reps: string;
}

interface BaseDay {
  dayOfWeek: DayOfWeek;
  title: string;
}

export interface TrainingDay extends BaseDay {
  kind: 'training';
  warmup?: string;
  entries: PlanEntry[];
  circuitNote?: string;
}

export interface PilatesDay extends BaseDay {
  kind: 'pilates';
  body: string;
}

export interface RecoveryDay extends BaseDay {
  kind: 'recovery';
  activities: string[];
}

export type DayPlan = TrainingDay | PilatesDay | RecoveryDay;

export interface LwsValidationError {
  exerciseId: string;
  reason: string;
}
